import { normalizeBusinessSlug } from './pageContext'

type ResolveWidgetSessionScopeArgs = {
  allBusinesses: boolean
  currentBusinessSlug?: string | null
  overrideBusinessSlug?: string | null
}

export type WidgetSessionScope =
  | {
      mode: 'notification-business'
      allBusinesses: false
      businessSlug: string
    }
  | {
      mode: 'all-businesses'
      allBusinesses: true
      businessSlug?: undefined
    }
  | {
      mode: 'current-business'
      allBusinesses: false
      businessSlug?: string
    }

export function resolveWidgetSessionScope({
  allBusinesses,
  currentBusinessSlug,
  overrideBusinessSlug
}: ResolveWidgetSessionScopeArgs): WidgetSessionScope {
  const overrideSlug = normalizeBusinessSlug(overrideBusinessSlug) ?? undefined
  if (overrideSlug) {
    return {
      mode: 'notification-business',
      allBusinesses: false,
      businessSlug: overrideSlug
    }
  }

  if (allBusinesses) {
    return {
      mode: 'all-businesses',
      allBusinesses: true
    }
  }

  return {
    mode: 'current-business',
    allBusinesses: false,
    businessSlug: normalizeBusinessSlug(currentBusinessSlug) ?? undefined
  }
}
